<bb-radio-list
	*ngIf="datasourceObj"
	[(ngModel)]="datasourceObj.sourceType"
	(ngModelChange)="onRadioChange($event)"
	[options]="radioOptions"
></bb-radio-list>
<div class="main-content" *ngIf="datasourceObj" [class.two-selectors]="fieldType === 'widgetSelector' || datasourceObj.sourceType === 'DatafeedValue'">
	<ie-form-field [label]="fieldLabel | translate"
	[useMacroSuggestions]="datasourceObj?.sourceType === 'PlainText' || datasourceObj?.sourceType === 'LocalStorage' || datasourceObj?.sourceType === 'QueryString'">
		<input
			*ngIf="fieldType === 'text'"
			type="text"
			class="ie-form-field-styling"
			[(ngModel)]="datasourceObj.sourceValue"
			(ngModelChange)="onValueChange($event)"
		/>
		<bb-entity-selector
			*ngIf="fieldType === 'entitySelector'"
			[(ngModel)]="datasourceObj.sourceValue"
			(ngModelChange)="onValueChange($event)"
			[options]="selectionOptions"
			name="value1"
			[extendable]="true"
			theme="dark"
		></bb-entity-selector>
		
		<bb-code-editor
			*ngIf="fieldType === 'scriptEditor'"
			[useMacroSuggestions]="true"
			[(ngModel)]="datasourceObj.sourceValue"
			class="ie-form-field-styling" 
			(ngModelChange)="onValueChange($event)"
			name="value1" 
		></bb-code-editor>

		<!-- widget has other model -->
		<bb-entity-selector
			*ngIf="fieldType === 'widgetSelector'"
			[(ngModel)]="widgetModel"
			(ngModelChange)="onValueChange($event)"
			[options]="selectionOptions"
			name="value1"
			[extendable]="true"
			theme="dark"
		></bb-entity-selector>

		<!-- datafeed has other model -->
		<bb-entity-selector
			*ngIf="fieldType === 'datafeedSelector'"
			[(ngModel)]="datafeedId"
			(ngModelChange)="onValueChange($event)"
			[options]="selectionOptions"
			[entityType]="'datafeed'"
			name="datafeed"
			theme="dark"
		></bb-entity-selector>
	</ie-form-field>

	<ie-form-field [label]="fieldLabel2 | translate" *ngIf="datasourceObj?.sourceType === 'DatafeedValue'" [title]="datafeedValue">
		<bb-entity-selector
			[disabled]="!datafeedId"
			[(ngModel)]="datafeedValue"
			(optionSelected)="onDatafeedValueSelected($event)"
			[options]="datafeedValueOptions"
			name="datafeedValue"
			theme="dark"
		></bb-entity-selector>
	</ie-form-field>
	
	<ie-form-field [label]="fieldLabel2 | translate" *ngIf="fieldType === 'widgetSelector'">
		<bb-entity-selector
			[(ngModel)]="widgetProperty"
			(ngModelChange)="onWidgetPropertyChange($event)"
			[options]="widgetPropertyOptions"
			name="value2"
			theme="dark"
		></bb-entity-selector>
	</ie-form-field>
</div>
<div class="button-bar">
	<div class="remove-button bar-button" (click)="onRemoveClick()">
		{{ 'REMOVE' | translate }}
	</div>
	
	<div class="bar-button" (click)="onCancelClick()">
		{{ 'CANCEL' | translate }}
	</div>

	<div class="ok-button bar-button" (click)="onOkClick()">
		{{ 'OK' | translate }}
	</div>
</div>
